import { actionTextColor } from "../../utils/themeContrast";
import { readableText } from "../../utils/themeContrast";
import React from "react";
import styled from "@emotion/styled";
import { ThemeContext } from "../../contexts/Context";

const ArrayBar = ({
  marginTop,
  marginBottom,
  setActiveState,
  produceNewState,
  produceArrayStateMulti,
  array,
  height,
  widthPercentage,
  bold,
  fontSize,
  lanIndex,
  isLanReverse,
  menuIndex,
  isMultiple
}) => {
  const themeContext = React.useContext(ThemeContext);

  return (
    <ArrayBarContainer
      height={height + 5}
      marginTop={marginTop}
      marginBottom={marginBottom}
      width={widthPercentage}
    >
      {array.map((item, index) => (
        <React.Fragment key={item.title + index}>
          <ArrayOption themeContext={themeContext}>
            <ArrayBarButton
              type="button"
              aria-pressed={Boolean(item.active)}
              fontSize={fontSize}
              bold={bold}
              themeContext={themeContext}
              onClick={() => {
                if (!isMultiple)
                  setActiveState(produceNewState(array, item.itemOptionId, false, false, menuIndex));
                else
                  setActiveState(produceArrayStateMulti(array, item.itemOptionId));
              }}
              index={index}
              activeState={item.active}
              array={array}
            >
              {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? item.title : item.title2 ? item.title2 : item.title}
            </ArrayBarButton>
          </ArrayOption>
        </React.Fragment>
      ))}
    </ArrayBarContainer>
  );
};

export default ArrayBar;

const ArrayBarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 42px;
  padding: 10px 16px;
  border: 1px solid ${props => props.activeState ? props.themeContext.primaryColor : (props.themeContext.optionBorderColor || props.themeContext.borderColor || "#ddd")};
  border-radius: 999px;
  background: ${props => props.activeState ? props.themeContext.primaryColor : (props.themeContext.barUnselectedBg || props.themeContext.backgroundColor || "#fff")};
  color: ${props => props.activeState
    ? actionTextColor(props.themeContext)
    : readableText(props.themeContext.barUnselectedBg || props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
  font-family: ${props => props.themeContext.fontFamily};
  font-size: ${props => props.fontSize || 14}px;
  font-weight: ${props => props.activeState || props.bold ? 600 : 400};
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
  &:focus-visible { outline: 2px solid ${props => props.themeContext.primaryColor}; outline-offset: 2px; }
`;

const ArrayOption = styled.div`
  display: flex;
  flex: 0 0 auto;
  min-width: 0;
`;

const ArrayBarContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  scrollbar-width: thin;
  gap: 8px;
  width: ${props => props.width || "100%"};
  margin-top: ${props => props.marginTop || 0}px;
  margin-bottom: ${props => props.marginBottom || 0}px;
`;
